import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const formAssetsValidatorSchema = {
    submitButtonIconName: Validator.optional(nonEmptyStringValidator),
    submitButtonLoadingIconName: Validator.optional(nonEmptyStringValidator),
    cancelButtonIconName: Validator.optional(nonEmptyStringValidator)
};
export const formAssetsValidator = Validator.object(formAssetsValidatorSchema);
